import { Link } from 'react-router-dom';
import Avatar from '../../profile/ui/Avatar';
import CardState from '../../profile/ui/CardState';

export default function ProfileSummaryCard({ summary, completeness, completenessLoading = false }) {
  // Identity renders as soon as the profile read lands. Completeness comes
  // from a live Odoo read and is slower, so it gets a placeholder in the
  // meter's slot (same height, so the card doesn't jump) instead of holding
  // the whole card back.
  if (summary.status === 'loading') {
    return <div className="home-card home-card--id"><CardState kind="loading" label="Loading your profile" lines={4} /></div>;
  }
  if (summary.status === 'error') {
    return (
      <div className="home-card home-card--id">
        <p className="home-muted">Couldn’t load your profile.</p>
        <button type="button" className="home-link-btn" onClick={summary.retry}>Try again</button>
      </div>
    );
  }

  const p = summary.profile;
  const org = [p.departments?.[0]?.name, p.odoo_company_name].filter(Boolean).join(' · ');
  const reports = summary.reportsCount;
  // The directory's name for the manager (short Nexus name), not the full
  // Odoo legal name; the Odoo name is only the fallback.
  const managerName = summary.managerName || p.odoo_manager_name;

  return (
    <div className="home-card home-card--id">
      <div className="home-id">
        <Avatar name={p.name} src={p.photo_url} size="home" />
        <div className="home-id__text">
          <span className="home-id__name">{p.name}</span>
          {p.odoo_job_title && <span className="home-id__title">{p.odoo_job_title}</span>}
          {org && <span className="home-id__org">{org}</span>}
        </div>
      </div>
      {(managerName || reports > 0) && (
        <ul className="home-id__facts">
          {managerName && <li>Manager: {managerName}</li>}
          {reports > 0 && <li>{reports} direct report{reports === 1 ? '' : 's'}</li>}
        </ul>
      )}
      {completenessLoading && (
        <div className="home-meter home-meter--pending">
          <CardState kind="loading" label="Loading profile completeness" lines={2} />
        </div>
      )}
      {!completenessLoading && completeness && (
        <div className="home-meter">
          <div className="home-meter__head">
            <span className="home-label">Profile</span>
            <span className="home-meter__value">{completeness.done} of {completeness.total} complete</span>
          </div>
          <div
            className="home-meter__track"
            role="progressbar"
            aria-label="Profile completeness"
            aria-valuemin={0}
            aria-valuemax={completeness.total}
            aria-valuenow={completeness.done}
          >
            <span style={{ width: `${Math.round((completeness.done / completeness.total) * 100)}%` }} />
          </div>
        </div>
      )}
      <Link className="btn btn-secondary home-card__cta" to="/profile">View full profile</Link>
    </div>
  );
}
